module.exports = __webpack_public_path__ + "static/redonions-81a93aeca63a555118f29002af981f06.jpg";